import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

// A production build served from this machine (a local preview of dist/) is not
// production traffic, and its stale-chunk errors would read as if it were.
const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);

Sentry.init({
  dsn: 'https://1a629aeb9afeb69efc07dc5a0697112c@o4511711835193344.ingest.us.sentry.io/4511712107364352',
  integrations: [
    Sentry.browserTracingIntegration(),
    // Masking ON, which is Sentry's default and was turned off here. This app
    // draws prescriptions: a replay of it is a patient's name, document,
    // diagnosis and medication, and `replaysOnErrorSampleRate: 1.0` means every
    // error recorded one. Health data is the most sensitive category the Web
    // Store and Habeas Data recognise, and a replay is the one signal that
    // carries it whole.
    //
    // Masked replays still answer what a replay is for — what the user clicked,
    // in what order, what the layout did — without carrying the text. Inputs are
    // masked by default; it is written out because the default is exactly what
    // got turned off before.
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, // Se traza el 10% de las transacciones
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.getaleia\.com\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.05, // This sets the sample rate at 5%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  environment: environment.production ? 'production' : 'development',
  enabled: environment.production && !isLocalHost,

  // Los releases son a nivel de organización, así que se prefija con el
  // proyecto para no colisionar con los del backend. Debe coincidir con el
  // release que crea factos_deploy.sh.
  release: 'factos-frontend@' + environment.version,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
